/*
 * @Description:
 * @Author: seam
 * @Date: 2021-08-10 11:58:38
 * @LastEditors: seam
 * @LastEditTime: 2021-08-19 15:08:55
 * @FilePath: \mgmt-client\src\store\modules\user.js
 */
import { Message } from 'view-design'
import { get } from '@/libs/axios'
import { get_tmType1 } from '@/api/tm'
export default {
  state: {
    anpaiToken: '',
    tmTypes: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.anpaiToken = token
    },
    SET_TYPES(state, types) {
      state.tmTypes = types
    }
  },
  actions: {
    // 获取查询token
    QueryToken() {
      return new Promise((resolve, reject) => {
        const url = '/tpi/anpai/token'
        get(url).then(res => {
          if (res.code === 0) {
            const token = res.data
            resolve(token)
          } else {
            Message.error(res.message)
            reject(res.message)
          }
        })
      })
    },
    getTmTypes() {
      return new Promise((resolve, reject) => {
        if (localStorage.getItem('tmTypes')) {
          resolve(JSON.parse(localStorage.getItem('tmTypes')))
        } else {
          get_tmType1().then(res => {
            const types = res.data.infor
            localStorage.setItem('tmTypes', JSON.stringify(types))
            resolve(types)
          }).catch(err => reject(err))
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js